import { OverlayConfig } from '@angular/cdk/overlay';
import { WizardDef } from './wizard.model';
export type WizardConfig = { wizard: WizardDef } & OverlayConfig;
export class WizardOverlayConfig extends OverlayConfig {
  wizardDef: WizardDef;
  constructor({ wizard: steps, ...options }: WizardConfig) {
    super(options);
    this.wizardDef = steps;
  }
}
